export function formatDate(d) {
  return (
    d.getFullYear() +
    "-" +
    zeroPad(d.getMonth() + 1) +
    "-" +
    zeroPad(d.getDate())
  );
}

export function zeroPad(n) {
  return n < 10 ? "0" + n : n;
}

export function monthDiff(d1, d2) {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

export function dayDiff(d1, d2) {
  let diffTime = Math.abs(d2 - d1);
  let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}

export function diffHours(dt2, dt1) {
  let diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
}


export const scaleZoom3 = {
  cellWidth: "60px",
  cellHeight: "55px",
  periodHeight: "60px",
  axisResourceWidth: '200px',
  taskStyle: {
    height: '38px',
    top: '5px'
  },
  timerStyle: {
    height: "38px",
    top: "5px",
  },
  parallelStyle: {
    height: "36px",
    width: '36px',
    top: "5px",
    iconSize: '20px' //height x width
  },
  conditionalStyle: {
    height: "36px",
    width: '36px',
    top: "5px",
  }


}

export const scaleZoom2 = {

  cellWidth: "50px",
  cellHeight: "45px",
  periodHeight: "50px",
  axisResourceWidth: '200px',
  taskStyle: {
    height: '28px',
    top: '5px'
  },
  timerStyle: {
    height: "28px",
    top: "5px",
  },
  parallelStyle: {
    height: "28px",
    width: '28px',
    top: "5px",
    iconSize: '18px' //height x width
  },
  conditionalStyle: {
    height: "28px",
    width: '28px',
    top: "5px",
  }


}

export const scaleZoom1 = {

  cellWidth: "40px",
  cellHeight: "35px",
  periodHeight: "40px",
  axisResourceWidth: '200px',
  taskStyle: {
    height: '23px',
    top: '5px'
  },
  timerStyle: {
    height: "23px",
    top: "5px",
  },
  parallelStyle: {
    height: "22px",
    width: '22px',
    top: "5px",
    iconSize: '14px' //height x width
  },
  conditionalStyle: {
    height: "22px",
    width: '22px',
    top: "5px",
  }


}